export default {
    ordersHistory: "تاریخچه سفارشات",
    filter: "فیلتر",
    trxRangeDate: "بازه زمانی تراکنش",
    pairCoin: "جفت ارز",
    orderType: "نوع سفارش",
    direction: "جهت بازار",
    buy: "خرید",
    sell: "فروش",
    status: "وضعیت",
    search: "جستجو",
    clearFilters: "پاک کردن فیلترها",
    limit: "محدود",
    market: "آنی",
    stopLimit: "حد سود/ضرر",
    oco: "OCO",
    marketPrice: "قیمت بازار",
    orderDetails: "جزییات سفارش",
    time: "زمان",
    type: "نوع",
    ocoLimit: "محدود (OCO)",
    marketOrder: "سفارش آنی",
    price: "قیمت",
    amount: "مقدار",
    turnOver: "حجم معاملات",
    ocoStopLimit: "حد سود/ضرر (OCO)",
    tradeDirection: "جهت معامله",
    activationPrice: "قیمت فعال‌سازی",
    description: "توضیحات",
    tradedAmount: "مقدار معامله‌شده",
    averageTradePrice: "میانگین قیمت معامله‌شده",
    finished: "تکمیل شده",
    canceled: "لغو شد",
    expired: "منقضی شده",
    refCode: "کد پیگیری",
    operation: "عملیات",
    details: "جزییات"
}